'use client';

import { stegaClean } from '@sanity/client/stega';

import { PageBlogOverviewSchema } from '@/sanity/pages/PageBlogOverviewTemplate';
import { DEFAULT_LANGUAGE } from '@/sanity/globals/I18n';
import { useIsMobile } from '@/hooks/useIsMobile';
import DesignScaleLock from '../global/DesignScaleLock';
import Footer from '../global/partials/Footer';
import HeaderV2 from '../global/partials/HeaderV2';
import ScrollingBanner from '../pageComponents/global/ScrollingBanner';
import BlogOverviewHero from '../pageComponents/blog/BlogOverviewHero';
import BlogGrid from '../pageComponents/blog/BlogGrid';

export default function PageBlogOverviewJSX({ data }: { data: PageBlogOverviewSchema }) {
  const language = stegaClean(data.settings?.language) || DEFAULT_LANGUAGE;
  const isMobile = useIsMobile();

  return (
    <main className="flex flex-col items-center bg-white">
      <DesignScaleLock />
      {data?.settings?.header && (
        <HeaderV2
          data={data.settings.header}
          headerStyle="light"
          headerType="main"
          language={data.settings?.language}
        />
      )}

      <BlogOverviewHero data={data} />
      <BlogGrid data={data} language={language} />

      <ScrollingBanner
        className="border-y-0 bg-[#f4f5f5] max-lg:h-[7.125rem] lg:h-[10rem]"
        words={data.scrollingWords?.words}
        wordsI18n={data.scrollingWords?.wordsI18n}
        wordClassName="font-bold lg:text-[2.25rem] lg:tracking-[0.045rem]"
        separatorClassName="rounded-none bg-black max-lg:!h-[0.375rem] max-lg:!w-[0.375rem]"
        gapRem={isMobile ? 4.75 : 6.625}
      />

      {data?.settings?.footer && (
        <Footer data={data.settings.footer} language={data.settings?.language} />
      )}
    </main>
  );
}
